import react, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import RLDD from 'react-list-drag-and-drop/lib/RLDD';
import toast from 'react-hot-toast';
import { addIdToData } from '../../utils';

let updateInterval = ""

const MultiListing = ({ setMultiInputs, setFieldValue, setShowMultiPriceForm, values, settings }) => {
 let [list, setList] = useState(addIdToData(values?.multiPriceList));

 useEffect(() => {
  setList(addIdToData(values?.multiPriceList));
 }, [values?.multiPriceList]);

 return (
  <>
   <div className='mt-2 ps-0'>
    <RLDD
     items={list}
     itemRenderer={(data, index) => {
      return (
       <div key={index} className="border cursor-grab bg-white p-2 mb-2 rounded list-unstyled">
        <div className="d-flex justify-content-between align-items-center">
         <div className="d-flex align-items-center gap-3">
          <h6 className="mb-0">{data?.title}</h6>
          {data?.description && (
           <small className="text-muted">{data?.description}</small>
          )}
         </div>
         <div className='d-flex gap-2'>
          <button
           type='button'
           className="btn btn-outline-dark btn-sm py-0 px-1"
           onClick={(e) => {
            e.preventDefault();
            setMultiInputs({ ...data, id: index });
            Swal.fire({
             title: "Are you sure?",
             text: "You want to edit!",
             icon: "info",
             showCancelButton: true,
             confirmButtonColor: "#3085d6",
             cancelButtonColor: "#d33",
             confirmButtonText: "Yes!"
            }).then((result) => {
             if (result.isConfirmed) {
              setShowMultiPriceForm(true);
             }
            });
           }}
          >
           <i className='fas fa-pencil-alt'></i>
          </button>
          <button
           type='button'
           className="btn btn-outline-dark btn-sm py-0 px-1"
           onClick={(e) => {
            e.preventDefault();
            Swal.fire({
             title: "Are you sure?",
             text: "You won't be able to revert this!",
             icon: "warning",
             showCancelButton: true,
             confirmButtonColor: "#3085d6",
             cancelButtonColor: "#d33",
             confirmButtonText: "Yes, delete it!"
            }).then((result) => {
             if (result.isConfirmed) {
              Swal.fire({
               title: "Deleted!",
               text: "Removed successfully.",
               icon: "success"
              });
              setFieldValue("multiPriceList", list?.filter((data, i) => i != index))
             }
            });
           }}
          >
           <i className='fas fa-trash'></i>
          </button>
         </div>
        </div>

        <div className="d-flex flex-wrap gap-2 mt-2">
         <div className="bg-light px-2 py-1 rounded d-flex align-items-center">
          <small className="text-muted me-1">Price:</small>
          <span className="fw-bold">{settings?.currencySymbol}{data?.sellPrice}</span>
          <del className="text-muted ms-1">{settings?.currencySymbol}{data?.oldPrice}</del>
         </div>

         <div className="bg-light px-2 py-1 rounded d-flex align-items-center">
          <small className="text-muted me-1">Cost:</small>
          <span className="fw-bold">{settings?.currencySymbol}{data?.cost}</span>
         </div>

         <div className="bg-light px-2 py-1 rounded d-flex align-items-center">
          <small className="text-muted me-1">Stock:</small>
          <span className="fw-bold">{data?.stockInHand}</span>
         </div>

         {data?.barCode && (
          <div className="bg-light px-2 py-1 rounded d-flex align-items-center">
           <i className='fas fa-barcode me-1'></i>
           <span className="text-muted">{data?.barCode}</span>
          </div>
         )}

         {values?.colorLinking && data?.colors?.length > 0 && data?.colors.map((color, colorIndex) => (
          <div key={colorIndex} className="bg-light px-2 py-1 rounded d-flex align-items-center gap-1">
           <div className='multiPriceColorBox' style={{ backgroundColor: color?.color }}></div>
           <span>{color.stockInHand}</span>
          </div>
         ))}
        </div>
       </div>
      )
     }}
     onChange={(data) => {
      console.log(data);
      setList(data)
      if (updateInterval) {
       clearTimeout(updateInterval);
      }
      updateInterval = setTimeout(() => {
       toast.success("Multi price list updated successfully.");
       setFieldValue("multiPriceList", data);
      }, 2000);
     }}
    />

   </div>
  </>
 )
}

export default MultiListing;